import { LitElement, html, svg } from "lit";
import { customElement, property, state } from "lit/decorators.js";

const copyIcon = svg`<path d="M7 7V4a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2h-1" stroke="currentColor" stroke-width="2" stroke-linecap="round" fill="none"/>
  <rect x="4" y="7" width="9" height="11" rx="2" stroke="currentColor" stroke-width="2" fill="none"/>`;

const checkIcon = svg`<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
  d="M4 9l4 4L16 5"/>`;

@customElement("copy-button")
export class CopyButton extends LitElement {
  @property() value = "";
  @property() label = "";
  @state() private _copied = false;

  createRenderRoot() {
    return this;
  }

  private async _copy(e: Event) {
    e.stopPropagation();
    await navigator.clipboard.writeText(this.value);
    this._copied = true;
    setTimeout(() => {
      this._copied = false;
    }, 2000);
  }

  render() {
    return html`
      <button
        @click=${this._copy}
        class="inline-flex items-center justify-center p-0.5
               ${this._copied ? "text-green-400" : "text-gray-500 hover:text-gray-200"}
               transition-colors cursor-pointer"
        title=${this._copied ? "Copied!" : `Copy${this.label ? ` ${this.label}` : ""}`}
      >
        <svg viewBox="0 0 20 20" fill="none" class="w-3.5 h-3.5">
          ${this._copied ? checkIcon : copyIcon}
        </svg>
      </button>
    `;
  }
}
